// 高德地图配置
const config={
  //高德地图key
  aMapKey: 'a5d277e50697a013a84345e88a7830e9',
  // 高德秘钥
  secretKey:'0e25d49d923ca0649983fee053d7fd7b',
  latLon: [125.158886, 49.029202], //嫩江前进镇231国道
}
export default config